import { useState } from 'react';

const WHATSAPP_NUMBER = '51992242237';
const WHATSAPP_MESSAGE =
  'Hola, me interesa una consultoría sobre arquitectura de software y optimización de procesos.';

function FloatingWhatsAppCTA() {
  const [open, setOpen] = useState(false);
  const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

  return (
    <div className="fixed bottom-5 right-4 z-[70] flex max-w-[92vw] flex-col items-end gap-3 sm:bottom-6 sm:right-6">
      {open && (
        <div className="w-[22rem] max-w-[92vw] rounded-2xl border border-outlineVariant/40 bg-white p-4 shadow-2xl">
          <div className="mb-3 flex items-start justify-between gap-3">
            <div>
              <p className="text-sm font-bold text-onSurface">Hablar con un Especialista</p>
              <p className="mt-1 text-xs text-onSurfaceVariant">Krystal Software</p>
            </div>
            <button
              type="button"
              onClick={() => setOpen(false)}
              className="rounded-md p-1 text-onSurfaceVariant hover:bg-surfaceContainer"
              aria-label="Cerrar chat"
            >
              <span className="material-symbols-outlined text-base">close</span>
            </button>
          </div>

          <p className="rounded-xl bg-surfaceContainerLow p-3 text-sm leading-relaxed text-onSurface">
            Te ayudamos a definir una consultoría técnica enfocada en arquitectura y mejora de procesos.
          </p>

          <a
            href={whatsappUrl}
            target="_blank"
            rel="noreferrer"
            className="mt-4 inline-flex w-full items-center justify-center rounded-lg bg-primary px-4 py-3 text-sm font-bold text-white transition hover:brightness-110"
          >
            Enviar mensaje por WhatsApp
          </a>
        </div>
      )}

      <button
        type="button"
        onClick={() => setOpen((value) => !value)}
        className="rounded-full bg-primary px-5 py-3 text-sm font-bold text-white shadow-xl shadow-primary/30 transition hover:brightness-110"
      >
        Hablar con un Especialista
      </button>
    </div>
  );
}

export default FloatingWhatsAppCTA;
